<template>
    <v-container fluid>
        <v-row>
            <v-col cols="9">
                <v-row>
                    <v-col>
                        <insurance-company-combo 
                            v-model="selectedInsuranceCompany" 
                            label="保險公司" 
                            :rules="[ (v) => !((v === null) || (v.name.trim()==''))|| '請選擇保險公司名稱' ]"
                            :items="this.insuranceCompanies">
                        </insurance-company-combo >
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <highcharts :options="options"></highcharts>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="3">
                <insurance-company-information-viewer :insurance_company_id="selectedCompany"></insurance-company-information-viewer>
            </v-col>
        </v-row>
        <p>{{message}}</p>
    </v-container>
</template>
<script>
import CommonDataService from '../../services/CommonDataService'
import ChartDataService from '../../services/ChartDataService'
import InsuranceCompanyCombo from '../../components/InsuranceCompanyCombo'
import InsuranceCompanyInformationViewer from '../../components/InsuranceCompany/InsuranceCompanyInformationViewer'
//import ComboBoxUtil from '../../utils/ComboBoxUtil'

export default {
    components: {
        InsuranceCompanyCombo,
        InsuranceCompanyInformationViewer
    },
    watch:{
        selectedInsuranceCompany: function(){
            this.queryData()
        },      
    },
    computed:{
        title(){
            return this.returnData.title
        },
        seriesData(){
            return this.returnData.series
        },
        options(){
            let options = Object.assign(this.chartOptions, {});

            options.title.text = this.title
            options.subtitle.text = '各商品投保年齡分析表'
            options.series = this.seriesData
            return options;
        },
        selectedCompany(){
            return this.selectedInsuranceCompany.id
        }
    },
    data(){
        return {
            message: '請選擇保險公司',
            /*
            cboInsuranceCompany: {
                id:null,
                name:null,
                labelName:'保險公司',
                checkRoles: [ v => !!v || '請選擇保險公司' ],
            },*/
            selectedInsuranceCompany:{id:-1, name:'', insurance_products:[]}, //v-model for 保險公司
            insuranceCompanies:[], //從API取的的保險公司＋商品資料，要注入至保險公司元件
            returnData: {
                title: null,
                series: null
            },
            chartOptions: {
                chart: { 
                    type: "column",
                    height: (9 / 16 * 100) + '%'
                },
                title: { 
                    text: "",
                    style: {
                        fontSize: "28px",
                        fontWeight: "bold",
                        textAlign: "right",
                        color: "#292929",
                        padding: "8px"
                    }
                },
                subtitle: { 
                    text: "",
                    style: {
                        fontSize: "20px",
                        fontWeight: "bold",
                        textAlign: "right",
                        color: "#292929",
                        padding: "8px"
                    }
                },
                xAxis: {
                    categories: ["30歲以下", "30-40歲", "40-50歲", "50-60歲", "60-70歲", "70歲以上"],
                    crosshair: true,
                    labels: { 
                        style: { 
                            fontSize:'15px' 
                        } 
                    } 
                },
                yAxis: {
                    title: { 
                        text: "投保人數" ,
                        style: { 
                            fontSize:'15px' 
                        } 
                    },
                    min:0
                },
                legend:{
                    itemStyle: {
                        font: '15pt Trebuchet MS, Verdana, sans-serif',
                        color: '#A0A0A0'
                    },
                },
                series: [],
            }
        }
    },
    created(){
        this.findInsuranceCompanies()
    },
    methods: {
        findInsuranceCompanies(){
            CommonDataService.findInsuranceCompanies().then((response)=>{
                this.insuranceCompanies = response.list
            }).catch(function (error) {
                console.log(error)
            })
        },
        queryData(){
            if ((this.selectedInsuranceCompany === null) || (this.selectedInsuranceCompany.id == -1)) {
                this.message = '請選擇保險公司後重新查詢'
                return 
            } else {
                ChartDataService.getProductAnalysisData(this.selectedInsuranceCompany.id, this.selectedInsuranceCompany.name)
                .then((response) => {
                        //console.log(response.data)
                        this.message = response.message
                        this.returnData = response.data
                    }
                ).catch(function (e) {
                        console.log(e);
                    }
                )
            } 
        }
    }
}
</script>
